/* eslint-disable max-lines */
import { CubeIcon, HardHatIcon, NotePencilIcon, RulerIcon, ShieldCheckIcon } from '@fronton/icons-react';
import { GalleryImage, ReviewBenefitStructure, ReviewStructure } from 'common/components';
import { BATHROOM_CDN_PATH } from '../bathroom-constants';

export const BATHROOM_CALCULATOR_HREF = '/kalkulyator-remonta/raschet-remonta-vannoy-komnaty/';

export const BATHROOM_SIGN_SECTION_GALLERY_LIST: GalleryImage[] = [
  {
    alt: 'Кухня в магазине с элементами дерева',
    src: `bathrooms-2/sign-section/modal/1.jpg/1.jpg`,
    srcSmall: `${BATHROOM_CDN_PATH}/sign-section/1.jpg/1-01.jpg`,
    name: 'Кухня в магазине с элементами дерева',
  },
  {
    alt: 'Кухня в магазине в серых тонах',
    src: `bathrooms-2/sign-section/modal/2.jpg/2.jpg`,
    srcSmall: `${BATHROOM_CDN_PATH}/sign-section/2.jpg/2.jpg`,
    name: 'Кухня в магазине в серых тонах',
  },
  {
    alt: 'Ассортимент кухонь в магазине',
    src: `bathrooms-2/sign-section/modal/3.jpg/3.jpg`,
    srcSmall: `${BATHROOM_CDN_PATH}/sign-section/3.jpg/3.jpg`,
    name: 'Ассортимент кухонь в магазине',
  },
];

export const BATHROOM_REVIEWS_BENEFITS_LIST: ReviewBenefitStructure[] = [
  {
    icon: RulerIcon,
    text: 'Сделаем\nточный замер',
    type: 'duotone',
  },
  {
    icon: CubeIcon,
    text: 'Подготовим\n3D-макет',
    type: 'duotone',
  },
  {
    icon: NotePencilIcon,
    text: 'Рассчитаем\nсмету',
    type: 'duotone',
  },
  {
    icon: HardHatIcon,
    text: 'Организуем\nремонт',
    type: 'duotone',
  },
  {
    icon: ShieldCheckIcon,
    text: 'Предоставим\nгарантию',
    type: 'duotone',
  },
];


export const BATHROOM_REVIEWS_LIST: ReviewStructure[] = [
  {
    imagesAlt: 'Review 1',
    images: [
      `${BATHROOM_CDN_PATH}/reviews-section/1-1.jpg/1-01.jpg`,
      `${BATHROOM_CDN_PATH}/reviews-section/1-2.jpg/1-2.jpg`,
      `${BATHROOM_CDN_PATH}/reviews-section/1-3.jpg/1-3.jpg`,
    ],
    bigImages: [
      `bathrooms-2/reviews-section/modal/1-1.jpg/1-01.jpg`,
      `bathrooms-2/reviews-section/modal/1-2.jpg/1-02.jpg`,
      `bathrooms-2/reviews-section/modal/1-3.jpg/1-03.jpg`,
    ],
    rating: 5,
    text:
      'Очень благодарна за\u00A0проект. Это уже не\u00A0первый мой проект в\u00A0Лемана ПРО. Очень хочется, чтобы открыли магазин где нибудь между Комсомольском и\u00A0Амурском!',
    date: '03 марта 2024 ',
    store: 'Южные врата',
  },
  {
    imagesAlt: 'Review 2',
    images: [
      `${BATHROOM_CDN_PATH}/reviews-section/2-1.jpg/2-01.jpg`,
      `${BATHROOM_CDN_PATH}/reviews-section/2-2.jpg/2-02.jpg`,
      `${BATHROOM_CDN_PATH}/reviews-section/2-3.jpg/2-3.jpg`,
    ],
    bigImages: [
      `bathrooms-2/reviews-section/modal/2-1.jpg/2-01.jpg`,
      `bathrooms-2/reviews-section/modal/2-2.jpg/2-02.jpg`,
      `bathrooms-2/reviews-section/modal/2-3.jpg/2-03.jpg`,
    ],
    rating: 5,
    text:
      'Кулемина Анна и\u00A0Дмитрий Батарбаев\u00A0\u2014 лучшие специалисты отдела. Умеют работать с\u00A0клиентами, выдержанные, доброжелательные, с\u00A0индивидуальным подходом к\u00A0каждому.',
    date: '3 марта 2024',
    store: 'Кемерово',
  },
  {
    imagesAlt: 'Review 3',
    images: [
      `${BATHROOM_CDN_PATH}/reviews-section/3-1.jpg/3-1.jpg`,
      `${BATHROOM_CDN_PATH}/reviews-section/3-2.jpg/3-2.jpg`,
    ],
    bigImages: [
      `bathrooms-2/reviews-section/modal/3-1.jpg/3-01.jpg`,
      `bathrooms-2/reviews-section/modal/3-2.jpg/3-02.jpg`,
    ],
    rating: 5,
    text:
      'Я\u00A0благодарен всем сотрудникам которые периодически консультируют меня в\u00A0Лемана ПРО Красный Бор, в\u00A0целом все сотрудники отзывчивые, и\u00A0любой вопрос решается!',
    date: '4 апреля 2024',
    store: 'Ярославль',
  },
  {
    imagesAlt: 'Review 4',
    images: [`${BATHROOM_CDN_PATH}/reviews-section/4-1.jpg/4-1.jpg`],
    bigImages: [`bathrooms-2/reviews-section/modal/4-1.jpg/4-01.jpg`],
    rating: 5,
    text:
      'Выражаю огромную благодарность специалисту по\u00A0проектированию ванных комнат Владиславу! С\u00A0его помощью сделано и\u00A0осуществлено уже 4\u00A0проекта\u00A0\u2014 от\u00A0проектировочных решений до\u00A0подбора и\u00A0доставки строительных материалов и\u00A0элементов декора. Владислав очень грамотный специалист, отлично знает ассортимент. С\u00A0Владиславом было очень приятно и\u00A0легко работать, он\u00A0понимает с\u00A0полуслова, чего хочет клиент, помогает, предлагает. По\u00A0моему мнению, Владислав\u00A0\u2014 лучший работник Лемана ПРО.',
    date: '11 марта 2024',
    store: 'Хабаровск',
  },
  {
    imagesAlt: 'Review 5',
    images: [`${BATHROOM_CDN_PATH}/reviews-section/5-1.jpg/5-1.jpg`],
    bigImages: [`bathrooms-2/reviews-section/modal/5-1.jpg/5-01.jpg`],
    rating: 5,
    text:
      'Выражаю огромную благодарность вашему сотруднику Маргарите\u00A0\u2014 всегда на\u00A0связи, отзывчивая, тактичная и\u00A0обязательная. Прошу поощрить её\u00A0премией.',
    date: '6 апреля 2024',
    store: 'Санкт-Петербург',
  },
  {
    imagesAlt: 'Review 6',
    images: [`${BATHROOM_CDN_PATH}/reviews-section/6-1.jpg/6-01.jpg`],
    bigImages: [`bathrooms-2/reviews-section/modal/6-1.jpg/6-01.jpg`],
    rating: 5,
    text:
      'Всё отлично, на\u00A0высшем уровне! Гайсина Оксана Жавдатовна\u00A0\u2014 отличный специалист, который хорошо разбирается в\u00A0товарах и\u00A0в\u00A0своей работе, воплотила нашу мечту в\u00A0реальность.',
    date: '14 мая 2024',
    store: 'Челябинск',
  },
  {
    imagesAlt: 'Review 7',
    images: [
      `${BATHROOM_CDN_PATH}/reviews-section/7-1.jpg/7-1.jpg`,
      `${BATHROOM_CDN_PATH}/reviews-section/7-2.jpg/7-2.jpg`,
      `${BATHROOM_CDN_PATH}/reviews-section/7-3.jpg/7-3.jpg`,
      `${BATHROOM_CDN_PATH}/reviews-section/7-4.jpg/7-4.jpg`,
    ],
    bigImages: [
      `bathrooms-2/reviews-section/modal/7-1.jpg/7-01.jpg`,
      `bathrooms-2/reviews-section/modal/7-2.jpg/7-02.jpg`,
      `bathrooms-2/reviews-section/modal/7-3.jpg/7-03.jpg`,
      `bathrooms-2/reviews-section/modal/7-4.jpg/7-04.jpg`,
    ],
    rating: 5,
    text:
      'Дизайнер Алексей Жук из\u00A0отдела плитки сделал прекрасный проект и\u00A0сопровождал на\u00A0всех этапах\u00A0\u2014 передайте сотруднику благодарность.',
    date: '1 марта 2024',
    store: 'Красноярск',
  },
  {
    imagesAlt: 'Review 8',
    images: [
      `${BATHROOM_CDN_PATH}/reviews-section/8-1.jpg/8-1.jpg`,
      `${BATHROOM_CDN_PATH}/reviews-section/8-2.jpg/8-2.jpg`,
    ],
    bigImages: [
      `bathrooms-2/reviews-section/modal/8-1.jpg/8-01.jpg`,
      `bathrooms-2/reviews-section/modal/8-2.jpg/8-02.jpg`,
    ],
    rating: 5,
    text: 'Елизавете, нашему консультанту, отдельное спасибо за\u00A0профессиональные знания, доброжелательность и\u00A0внимание к\u00A0индивидуальным деталям нашей ванной комнаты. Без Елизаветы нашему мастеру наверняка было\u00A0бы намного труднее сделать всё без погрешностей. Всем спасибо, с\u00A0праздником 8\u00A0марта, будьте здоровы и\u00A0счастливы!',
    date: '6 марта 2024',
    store: 'Тверь',
  },
  {
    imagesAlt: 'Review 9',
    images: [
      `${BATHROOM_CDN_PATH}/reviews-section/9-1.jpg/9-1.jpg`,
      `${BATHROOM_CDN_PATH}/reviews-section/9-2.jpg/9-2.jpg`,
    ],
    bigImages: [
      `bathrooms-2/reviews-section/modal/9-1.jpg/9-01.jpg`,
      `bathrooms-2/reviews-section/modal/9-2.jpg/9-02.jpg`,
    ],
    rating: 5,
    text: 'Заказывали проект \u00ABВанная комната\u00BB.Спасибо консультанту Вадиму за\u00A0помощь в\u00A0реализации нашей идеи!',
    date: '15 мая 2024',
    store: 'Смоленск',
  },
  {
    imagesAlt: 'Review 10',
    images: [
      `${BATHROOM_CDN_PATH}/reviews-section/10-1.jpg/10-1.jpg`,
      `${BATHROOM_CDN_PATH}/reviews-section/10-2.jpg/10-2.jpg`,
    ],
    bigImages: [
      `bathrooms-2/reviews-section/modal/10-1.jpg/10-01.jpg`,
      `bathrooms-2/reviews-section/modal/10-2.jpg/10-02.jpg`,
    ],
    rating: 5,
    text:
      'Хочу отметить отличную и\u00A0высокопрофессиональную работу специалиста Абдулхалимова Ислама\u00A0\u2014 его доброжелательность, знание своего дела, вежливость и\u00A0внимание. Выражаю ему свою благодарность.',
    date: '26 мая 2024',
    store: 'Киевское шоссе',
  },
  {
    imagesAlt: 'Review 11',
    images: [
      `${BATHROOM_CDN_PATH}/reviews-section/11-1.jpg/11-1.jpg`,
      `${BATHROOM_CDN_PATH}/reviews-section/11-2.jpg/11-2.jpg`,
    ],
    bigImages: [
      `bathrooms-2/reviews-section/modal/11-1.jpg/11-01.jpg`,
      `bathrooms-2/reviews-section/modal/11-2.jpg/11-02.jpg`,
    ],
    rating: 5,
    text:
      'Хочу выразить благодарность Татьяне за\u00A0наш проект ванной и\u00A0санузла. Она не\u00A0только настоящий профессионал, но\u00A0и\u00A0чуткий, понимающий человек.',
    date: '22 июля 2024',
    store: 'Выхино',
  },
  {
    imagesAlt: 'Review 12',
    images: [
      `${BATHROOM_CDN_PATH}/reviews-section/12-1.jpg/12-1.jpg`,
      `${BATHROOM_CDN_PATH}/reviews-section/12-2.jpg/12-2.jpg`,
      `${BATHROOM_CDN_PATH}/reviews-section/12-3.jpg/12-3.jpg`,
    ],
    bigImages: [
      `bathrooms-2/reviews-section/modal/12-1.jpg/12-01.jpg`,
      `bathrooms-2/reviews-section/modal/12-2.jpg/12-02.jpg`,
      `bathrooms-2/reviews-section/modal/12-3.jpg/12-03.jpg`,
    ],
    rating: 5,
    text:
      'Хочу поблагодарить дизайнера Екатерину из\u00A0отдела \u00ABПроектирование ванных комнат\u00BB. Очень эмпатичный специалист. Всегда была на\u00A0связи, на\u00A0протяжении всего сотрудничества оставалась вежливой, ненавязчиво предлагала свои варианты решения и\u00A0оптимизировала наше время. Очень ей\u00A0благодарна, остались только положительные эмоции.',
    date: '13 августв 2024',
    store: 'Оренбург',
  },
];
